import { IIndividualProjectPageService } from '../../services/individual-project-page.service';
import { getIconByName } from '../../styles/icons';
import { ICONS } from '../enums/generic.enum';

export interface IGridHyperlink {
  value: string;
  id: string;
  vppaId: string;
  iconList: Array<{ icon: ICONS; width; height; fill? }>;
}

export class HyperlinkCellRenderer {
  @IIndividualProjectPageService individualProjectPageService: IIndividualProjectPageService;
  constructor() {
    this.content = document.createElement('span');
    this.content.setAttribute('part', 'hyperlink');
  }

  init(params: IGridHyperlink) {
    if (!params.value) {
      return null;
    }
    this.content.innerText = params.value;
    this.content.addEventListener('click', () => {
      this.individualProjectPageService.openIndividualProjectPage(params.id, params.vppaId);
    });
  }

  content: HTMLElement;
  refresh(): boolean {
    return true;
  }
  getGui(): HTMLElement {
    return this.content;
  }
}

export class HyperlinkStaticCellRenderer {
  @IIndividualProjectPageService individualProjectPageService: IIndividualProjectPageService;
  constructor() {
    this.content = document.createElement('div');
    this.content.setAttribute('part', 'iconsAndLink');
    this.link = document.createElement('span');
  }

  init(params: IGridHyperlink) {
    if (!params.value) {
      return null;
    }
    if (params.iconList) {
      params.iconList.forEach((elm) => {
        const newIcon = document.createElement('span');
        newIcon.setAttribute('part', 'iconWrapper');
        newIcon.innerHTML = getIconByName(elm.icon, null, elm.width, elm.height, elm.fill);
        this.content.appendChild(newIcon);
      });
    }
    if (!params.id) {
      this.link.innerText = params.value;
      this.content.appendChild(this.link);
      return;
    }
    this.link.setAttribute('part', 'hyperlink');
    this.link.innerText = params.value;
    this.content.appendChild(this.link);
    this.link.addEventListener('click', () => {
      this.individualProjectPageService.openIndividualProjectPage(params.id, params.vppaId);
    });
  }

  content: HTMLElement;
  link: HTMLElement;

  clearContent() {
    while (this.content.firstChild) {
      this.content.removeChild(this.content.firstChild);
    }
  }

  refresh(params): boolean {
    this.clearContent();
    const cellRendererParams = params.colDef.cellRendererParams;
    const updatedParams = cellRendererParams(params);
    this.init(updatedParams);
    return true;
  }

  getGui(): HTMLElement {
    return this.content;
  }
}
